var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeChartPieSliceSizemWeightfilled = function SvgTypeChartPieSliceSizemWeightfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#FDFDFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "M18.75 11.999a6.748 6.748 0 0 1-9.298 6.252 6.75 6.75 0 0 1-3.273-2.832.52.52 0 0 1 .187-.714l5.115-2.977V5.77A.52.52 0 0 1 12 5.25a6.75 6.75 0 0 1 5.845 3.372l.018.036a6.7 6.7 0 0 1 .887 3.34"
  })));
};
export default SvgTypeChartPieSliceSizemWeightfilled;